<template>
  <div>
    <!-- Header -->
    <header class="w-full">
      <!-- Top bar -->
      <div class="bg-[#6E4082] text-white text-sm px-3 md:px-0">
        <div class="container mx-auto flex justify-between items-center">
          <a href="https://wize.pe" target="_blank" class="flex items-center gap-2">
            <img src="@/core/assets/images/logos/logo-wize.png" alt="Logo Wize" class="h-8" />
          </a>

          <div class="flex justify-end items-center gap-3 py-2">
            <a :href="adminUrl" target="_blank"
              class="rounded-full px-2 px-md-3 py-1 text-sm bg-white/15 text-white hover:bg-white/25 transition">
              <i class="ri-login-box-line"></i> Ingresar al Sistema
            </a>
            <a href="https://wa.me/51908901200?text=Hola%2C%20estoy%20interesado%20en%20Zet%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n.
" target="_blank" class="rounded-full px-2 px-md-3 py-1 text-sm bg-white/15 text-white hover:bg-white/25 transition">
              <i class="ri-customer-service-2-line"></i> Soporte
            </a>
          </div>
        </div>
      </div>

      <!-- Main navbar -->
      <div class="container mx-auto flex justify-between items-center py-4 px-3 md:px-0">
        <a href="#" class="flex items-center">
          <img src="@/core/assets/images/logos/logo-zet.png" alt="Logo Zet" class="h-12" />
          <span class="font-roboto font-bold text-2xl text-[#84509A]">ZET</span>
        </a>

        <!-- Menu button (mobile) -->
        <button id="menuBtn" class="md:hidden p-2 rounded-lg hover:bg-gray-100" aria-label="Abrir menú"
          aria-controls="mobilePanel" aria-expanded="false">
          <i class="ri-menu-line text-2xl"></i>
        </button>

        <!-- Links (desktop) -->
        <ul id="menu" class="hidden md:flex justify-content-between w-100 items-center text-sm mb-0 pl-5">
          <div class="d-flex justify-content-center flex-1">
            <li class="mx-2"><a href="#beneficios" class="font-medium hover:text-[#84509A]" v-smooth-scroll>Beneficios</a>
            </li>
            <li class="mx-2"><a href="#planes" class="font-medium hover:text-[#84509A]" v-smooth-scroll>Planes</a></li>
            <li class="mx-2"><a href="#testimonios" class="font-medium hover:text-[#84509A]"
                v-smooth-scroll>Testimonios</a></li>
            <li class="mx-2"><a href="#preguntas-frecuentes" class="font-medium hover:text-[#84509A]"
                v-smooth-scroll>Preguntas frecuentes</a></li>
          </div>
          <li>
            <a href="https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20Zet%20-%20Libro%20de%20Reclamaciones"
              target="_blank" class="rounded-full px-4 py-2 bg-[#84509A] text-white hover:bg-[#84509A] transition">
              Solicita una demostración
              <i class="ri-arrow-right-up-line ml-2"></i>
            </a>
          </li>
        </ul>
      </div>

      <!-- Mobile off-canvas -->
      <!-- Overlay -->
      <div id="mobileOverlay" class="fixed inset-0 z-40 bg-black/40 hidden opacity-0 transition-opacity md:hidden">
      </div>

      <!-- Panel -->
      <aside id="mobilePanel"
        class="fixed inset-y-0 right-0 z-50 w-80 max-w-[85%] bg-white shadow-xl translate-x-full transition-transform md:hidden">
        <div class="px-4 py-4 border-b border-gray-200 flex items-center justify-between">
          <span class="font-semibold">Menú</span>
          <button id="closeMenu" class="p-2 rounded-lg hover:bg-gray-100" aria-label="Cerrar menú">
            <i class="ri-close-line text-2xl"></i>
          </button>
        </div>
        <nav class="px-4 py-3">
          <a href="#beneficios" class="font-medium block py-2" v-smooth-scroll>Beneficios</a>
          <a href="#planes" class="font-medium block py-2" v-smooth-scroll>Planes</a>
          <a href="#testimonios" class="font-medium block py-2" v-smooth-scroll>Testimonios</a>
          <a href="#preguntas-frecuentes" class="font-medium block py-2" v-smooth-scroll>Preguntas frecuentes</a>
          <a href="https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20Zet%20-%20Libro%20de%20Reclamaciones" target="_blank"
            class="mt-3 block rounded-full px-4 py-2 text-center bg-[#84509A] text-white hover:bg-[#84509A] transition">Solicita una demostración</a>
        </nav>
      </aside>
    </header>

    <!-- Hero / Banner -->
    <section id="hero" class="relative overflow-hidden">
      <div
        class="absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-[#84509A]/10 to-transparent pointer-events-none">
      </div>
      <div class="container mx-auto grid lg:grid-cols-2 gap-10 items-center pt-20 pb-10 px-4 md:px-6">
        <!-- Left: copy -->
        <div data-aos="fade-right">
          <span class="inline-flex items-center gap-2 text-sm text-[#84509A] font-semibold">
            ¡Hola! Somos ZET.
          </span>

          <h1 class="mt-3 banner-title text-3xl sm:text-5xl lg:text-5xl font-extrabold leading-tight text-slate-900">
            Simplifica tu Libro de Reclamaciones Virtual
          </h1>

          <p class="mt-3 text-lg text-slate-600 max-w-2xl">
            Digitaliza y gestiona tus reclamos de forma rápida y segura cumpliendo con la normativa de Indecopi
          </p>

          <div class="mt-8">
            <a href="https://wa.me/51908901200?text=Hola%2C%20estoy%20interesado%20en%20Zet%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n."
              target="_blank"
              class="inline-flex items-center gap-2 rounded-xl bg-[#6E4082] px-6 py-3 text-white font-semibold hover:bg-[#6E4082] transition">
              Adquiere tu Libro de Reclamaciones
            </a>
          </div>
        </div>

        <!-- Right: illustration -->
        <div class="relative flex justify-center" data-aos="fade-left">
          <img src="@/core/assets/images/home/banner-1.png" alt="Zet - Libro de reclamaciones" class="heartbeat">
        </div>
      </div>
    </section>

    <!-- ===================== -->
    <!-- Beneficios (Section) -->
    <!-- ===================== -->
    <section id="beneficios" class="relative pt-20 bg-white">
      <div class="container mx-auto px-4 md:px-6">
        <!-- Header -->
        <div class="text-center max-w-3xl mx-auto" data-aos="fade-up">
          <p class="text-sm font-semibold tracking-wide text-[#84509A] mb-2">¿Por qué usar ZET?</p>
          <h2 class="text-3xl sm:text-4xl font-extrabold text-slate-900">
            Beneficios de nuestra plataforma
          </h2>
          <p class="mt-3 text-slate-600">
            Ideal para negocios que no tienen tiempo para lidiar con procesos legales.
          </p>
        </div>

        <!-- Grid -->
        <div class="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <!-- Card 1 -->
          <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="0">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-check-double-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="text-xl font-semibold text-slate-900">Cumplimiento legal sin dolores de cabeza</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Cumples con la Ley N.° 29571 sin complicaciones ni procesos engorrosos.
            </p>
          </article>

          <!-- Card 2 -->
          <!-- <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="50">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-customer-service-2-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="font-semibold text-slate-900">Gestión de reclamos</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Nosotros gestionamos tus reclamos si lo deseas, liberándote de esa carga.
            </p>
          </article> -->

          <!-- Card 3 -->
          <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="100">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-time-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="text-xl font-semibold text-slate-900">Disponibilidad 24/7</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Tu libro de reclamaciones digital siempre accesible para tus clientes.
            </p>
          </article>

          <!-- Card 4 -->
          <!-- <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="150">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-qr-code-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="font-semibold text-slate-900">Acceso multicanal</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Desde tu web, redes sociales o QR físico, sin barreras para tus clientes.
            </p>
          </article> -->

          <!-- Card 5 -->
          <!-- <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="200">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-server-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="font-semibold text-slate-900">Hosting incluido</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Sin configuraciones complicadas. Tu sistema listo para usar desde el primer día.
            </p>
          </article> -->

          <!-- Card 6 -->
          <article class="group rounded-2xl bg-[#F9FAFB] p-4 shadow-sm transition hover:shadow-md" data-aos="fade-up"
            data-aos-delay="250">
            <div class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#84509A]/10">
              <i class="ri-medal-line text-2xl text-[#84509A]"></i>
            </div>
            <h3 class="text-xl font-semibold text-slate-900">Compatible con Indecopi</h3>
            <p class="mt-2 mb-0 text-sm leading-relaxed text-slate-600">
              Asegura el cumplimiento de todos los requisitos establecidos por Indecopi.
            </p>
          </article>
        </div>
      </div>
    </section>

    <!-- Custommers -->
    <section id="Custommers" class="mt-10 mx-auto lg:max-w-[945px] xl:max-w-[1116px]">
      <div class="bg-wize-light p-6 md:rounded-xl md:pt-16 md:pb-[52px] md:px-8">
        <h4 class="text-3xl text-center sm:text-4xl font-extrabold text-slate-900 mb-3">
          Marcas destacadas confían en ZET
        </h4>

        <!-- Mobile -->
        <swiper class="swiper swiper-products-carousel md:hidden" :options="swiperOptionsMobile">
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-grupoauren-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-mercadon-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-mikshito-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-orbitalelevadores-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-reinodelvalle-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-travelcab-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-lanapolis-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-rackperu-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-stf-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
        </swiper>

        <!-- Desktop -->
        <swiper class="swiper swiper-products-carousel mt-6 hidden md:block" :options="swiperOptionsDesktop">
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-grupoauren-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-mercadon-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-mikshito-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-orbitalelevadores-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-reinodelvalle-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-travelcab-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-lanapolis-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-rackperu-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
          <swiper-slide class="slider_item">
            <img src="@/core/assets/images/home/custommers/logo-stf-desktop.svg" alt="Zet - Libro de reclamaciones" />
          </swiper-slide>
        </swiper>

        <!-- <div class="hidden cursor-pointer md:block md:mt-[40px]">
          <div id="swiper-custommers-desktop" class="swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide flex justify-center items-center">
                <img src="@/core/assets/images/home/custommers/logo-blackversion.png" alt="Razzil" />
              </div>
              <div class="swiper-slide flex justify-center items-center">
                <img src="@/core/assets/images/home/custommers/logo-mercadon.png" alt="Razzil" />
              </div>
              <div class="swiper-slide flex justify-center items-center">
                <img src="@/core/assets/images/home/custommers/logo-reddigital.png" alt="Razzil" />
              </div>
              <div class="swiper-slide flex justify-center items-center">
                <img src="@/core/assets/images/home/custommers/logo-casarepublica.png" alt="Razzil" />
              </div>
              <div class="swiper-slide flex justify-center items-center">
                <img src="@/core/assets/images/home/custommers/logo-sineditor.png" alt="Razzil" />
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </section>

    <!-- ===================== -->
    <!-- Cumplimiento (Hero Card) -->
    <!-- ===================== -->
    <section class="py-10 px-4 md:px-6">
      <div class="relative mx-auto max-w-6xl rounded-[28px] shadow-xl overflow-hidden" data-aos="fade-up">
        <!-- Fondo con degradado -->
        <div class="absolute inset-0 bg-gradient-to-r from-[#84509A] via-[#9460B2] to-[#A77ACE]"></div>

        <!-- Sombra interior suave (borde claro como en el diseño) -->
        <div class="absolute inset-0 ring-1 ring-white/30"></div>

        <!-- Contenido -->
        <div class="relative grid lg:grid-cols-2 items-center gap-8 p-8 sm:p-12">
          <!-- Columna izquierda vacía (reemplaza la imagen omitida para mantener el balance) -->
          <div class="hidden lg:block">
            <img src="@/core/assets/images/home/banner-indecopi.png" alt="Zet - Libro de reclamaciones"
              class="heartbeat">
          </div>

          <!-- Columna de texto -->
          <div class="text-white">
            <h2 class="text-3xl sm:text-4xl font-bold leading-tight drop-shadow-sm">
              Cumple con Ley N.º 29571 del Código de Protección y Defensa del Consumidor
            </h2>

            <p class="mt-4 text-white/80 max-w-2xl">
              Toda empresa que ofrece bienes o servicios al consumidor final debe contar con un Libro
              de Reclamaciones.
            </p>

            <!-- Bullets cortos -->
            <ul class="mt-4 space-y-2 text-white/90">
              <li class="flex items-start gap-1">
                ✅
                <span>ZET cumple con la normativa vigente y te ayuda a evitar sanciones por
                  incumplimiento.</span>
              </li>
            </ul>

            <!-- “Trust badge” al estilo Trustpilot -->
            <div class="mt-6 inline-flex items-center gap-3 rounded-xl bg-white/95 text-slate-800 px-4 py-3 shadow">
              <div class="inline-flex items-center gap-1">
                <span class="text-xs font-semibold mr-1">Confianza</span>
                <i class="ri-star-fill"></i>
                <i class="ri-star-fill"></i>
                <i class="ri-star-fill"></i>
                <i class="ri-star-fill"></i>
                <i class="ri-star-half-fill"></i>
              </div>
              <span class="text-sm text-slate-600">4.8/5 basado en experiencias reales</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== -->
    <!-- ¿ZET es para ti? -->
    <!-- ===================== -->
    <section class="relative py-16 bg-white">
      <!-- Glow sutil -->
      <div class="pointer-events-none absolute -top-24 -left-20 h-56 w-56 rounded-full bg-[#84509A]/10 blur-3xl">
      </div>

      <div class="container mx-auto px-4 md:px-6">
        <!-- Header -->
        <div class="text-center max-w-3xl mx-auto" data-aos="fade-up">
          <span
            class="inline-flex items-center gap-2 rounded-full bg-[#84509A]/10 px-3 py-1 text-xs font-semibold text-[#84509A]">
            ¿ZET es para ti?
          </span>
          <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
            ZET funciona si tu negocio <span class="text-[#84509A]">atiende personas</span>
          </h2>
        </div>

        <!-- Listado -->
        <div class="zet-details mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-aos="fade-up" data-aos-delay="50">
          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🏬</div>
            <div>
              <h3 class="font-semibold text-slate-900">Tiendas virtuales o físicas</h3>
              <p class="my-0 text-sm text-slate-600">E-commerce, retail, bodegas, boutiques.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🍽️</div>
            <div>
              <h3 class="font-semibold text-slate-900">Restaurantes y dark kitchens</h3>
              <p class="my-0 text-sm text-slate-600">Delivery, food courts y cafeterías.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🏥</div>
            <div>
              <h3 class="font-semibold text-slate-900">Clínicas, dentales y centros médicos</h3>
              <p class="my-0 text-sm text-slate-600">Consultorios, laboratorios y ópticas.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🏫</div>
            <div>
              <h3 class="font-semibold text-slate-900">Colegios e instituciones educativas</h3>
              <p class="my-0 text-sm text-slate-600">Academias, institutos y universidades.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">✈️</div>
            <div>
              <h3 class="font-semibold text-slate-900">Agencias de viajes y turismo</h3>
              <p class="my-0 text-sm text-slate-600">Operadores, hoteles y tours.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">💆‍♀️</div>
            <div>
              <h3 class="font-semibold text-slate-900">Salones de belleza y spa</h3>
              <p class="my-0 text-sm text-slate-600">Barberías, estética y bienestar.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🧑‍💼</div>
            <div class="flex-1">
              <h3 class="font-semibold text-slate-900">Profesionales independientes</h3>
              <p class="my-0 text-sm text-slate-600">Abogados, contadores, técnicos y más.</p>
            </div>
          </div>

          <!-- NUEVOS -->
          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🏨</div>
            <div>
              <h3 class="font-semibold text-slate-900">Hoteles y alojamientos</h3>
              <p class="my-0 text-sm text-slate-600">Hostales, resorts, albergues y hospedajes.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 rounded-2xl bg-slate-100 py-3 pl-2 hover:bg-slate-50 transition">
            <div class="text-2xl leading-none">🚗</div>
            <div>
              <h3 class="font-semibold text-slate-900">Empresas de transporte</h3>
              <p class="my-0 text-sm text-slate-600">Taxis, buses, transporte turístico y de carga.</p>
            </div>
          </div>
        </div>

        <!-- CTA opcional -->
        <div class="mt-10 text-center" data-aos="fade-up" data-aos-delay="100">
          <a href="https://api.whatsapp.com/send/?phone=51908901200&text=Hola%2C+quiero+informaci%C3%B3n+sobre+Zet+-+Libro+de+Reclamaciones&type=phone_number&app_absent=0" target="_blank"
            class="inline-flex items-center gap-2 rounded-xl bg-[#84509A] px-5 py-3 text-white font-semibold hover:bg-[#6f3e80] transition">
            ¿Te reconociste? Pide una demo <i class="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>

    <PricingPlans />

    <!-- ===================== -->
    <!-- CTA: Solicita tu demo -->
    <!-- ===================== -->
    <section id="solicitar-demo" class="relative overflow-hidden py-16">
      <!-- Glow / decor -->
      <div class="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[#84509A]/20 blur-3xl">
      </div>
      <div class="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#14B8A6]/20 blur-3xl">
      </div>

      <div class="container mx-auto grid items-center gap-10 px-4 md:px-6 lg:grid-cols-2">
        <!-- Copy -->
        <div data-aos="fade-right" class="relative">
          <!-- Overline -->
          <span
            class="inline-flex items-center gap-2 rounded-full bg-[#84509A]/10 px-3 py-1 text-xs font-semibold text-[#84509A]">
            <i class="ri-flashlight-line"></i> Prueba ZET hoy mismo
          </span>

          <h2 class="mt-4 text-3xl sm:text-4xl font-extrabold leading-tight text-slate-900">
            Solicita una <span class="text-[#84509A]">demo gratuita</span>
          </h2>

          <!-- <p class="mt-3 text-slate-600">
                    Descubre cómo <strong>ZET</strong> te ayuda a cumplir con la <strong>Ley N.º 29571</strong> y con
                    <strong>Indecopi</strong> mientras gestionas tu Libro de Reclamaciones virtual de forma simple y
                    segura.
                </p> -->

          <!-- Bullets -->
          <ul class="mt-6 grid gap-3 sm:grid-cols-2">
            <li class="flex items-center gap-2 text-slate-700">
              <i class="ri-check-line text-green-500"></i> Sin tarjeta, sin compromiso
            </li>
            <li class="flex items-center gap-2 text-slate-700">
              <i class="ri-check-line text-green-500"></i> Configuración guiada en minutos
            </li>
          </ul>

          <!-- Actions -->
          <div class="mt-6 flex flex-col gap-3 sm:flex-row">
            <a href="https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20Zet%20-%20Libro%20de%20Reclamaciones"
              target="_blank"
              class="inline-flex items-center justify-center rounded-xl bg-[#84509A] px-5 py-3 font-semibold text-white transition hover:bg-[#6f3e80]">
              Probar gratis ahora
              <i class="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a href="#planes"
              class="inline-flex items-center justify-center rounded-xl border border-slate-300 px-5 py-3 font-semibold text-slate-700 hover:bg-slate-50">
              Ver planes
              <i class="ri-price-tag-3-line ml-2"></i>
            </a>
          </div>

          <!-- Nota -->
          <p class="mt-2 text-sm text-slate-500 mt-4">Demo guiada por un especialista. Duración aprox. 10 min.</p>

          <!-- Badge de confianza -->
          <!-- <div
                    class="mt-6 inline-flex items-center gap-3 rounded-xl border border-slate-200 bg-white/90 px-4 py-2 shadow-sm">
                    <i class="ri-shield-check-line text-[#14B8A6] text-xl"></i>
                    <span class="text-sm text-slate-700">Cumple con Indecopi y Ley N.º 29571</span>
                </div> -->
        </div>

        <!-- Visual (reemplaza este div con tu imagen final) -->
        <div data-aos="fade-left" class="relative">
          <!-- Tarjeta para enmarcar la imagen -->
          <div class="relative rounded-3xl bg-slate-100 p-4 md:p-6 shadow-sm">
            <!-- Placeholder: pega aquí la imagen sin fondo que generaste -->
            <div
              class="aspect-[4/3] w-full rounded-2xl bg-gradient-to-br from-white to-slate-50 grid place-items-center">
              <img src="@/core/assets/images/home/demo.png" alt="">
            </div>
          </div>

          <!-- Motivos decorativos sutiles -->
          <div class="pointer-events-none absolute -right-6 -bottom-6 h-20 w-20 rotate-12 rounded-2xl bg-[#84509A]/10">
          </div>
          <div class="pointer-events-none absolute -left-6 -top-6 h-16 w-16 -rotate-6 rounded-full bg-[#14B8A6]/10">
          </div>
        </div>
      </div>
    </section>

    <!-- ===== FAQ / Frequently Asked Questions ===== -->
    <section id="preguntas-frecuentes" class="pt-8 pb-16 bg-white">
      <div class="max-w-3xl mx-auto px-4">
        <!-- Header -->
        <div class="text-center mb-8">
          <h2 class="text-3xl sm:text-4xl font-extrabold text-slate-900">Preguntas frecuentes</h2>
          <p class="mt-2 text-slate-500">¿Tienes preguntas? Tenemos respuestas.</p>
        </div>

        <!-- List -->
        <div class="space-y-3" id="faqList" data-allow-multiple="false">
          <!-- Item 1 -->
          <article class="faq-item rounded-xl">
            <button id="q1" aria-expanded="false" aria-controls="p1" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
           hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Cumple con las exigencias <br class="lg:hidden"> de Indecopi?
              </span>
              <span class="inline-block icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p1" role="region" aria-labelledby="q1" class="faq-panel overflow-hidden px-5 bg-slate-100"
              style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                Sí. ZET está alineado con la normativa vigente y el formato requerido.
              </div>
            </div>
          </article>


          <!-- Item 2 -->
          <article class="faq-item rounded-xl">
            <button id="q2" aria-expanded="false" aria-controls="p2" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
                 hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Necesito tener una página web?
              </span>
              <span class="icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p2" role="region" aria-labelledby="q2"
              class="faq-panel overflow-hidden px-5 rounded-b-2xl bg-slate-100" style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                No. Te damos una URL tipo <span class="text-blue-500 font-bold">tumarca.zet.pe</span> para
                que puedas compartirla directamente en tus
                redes o colocarla en tu local.
              </div>
            </div>
          </article>

          <!-- Item 3 -->
          <article class="faq-item rounded-xl">
            <button id="q3" aria-expanded="false" aria-controls="p3" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
                 hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Puedo usarlo desde el celular?
              </span>
              <span class="icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p3" role="region" aria-labelledby="q3"
              class="faq-panel overflow-hidden px-5 rounded-b-2xl bg-slate-100" style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                Sí. ZET es 100% responsivo y se adapta a cualquier dispositivo.
              </div>
            </div>
          </article>

          <!-- Item 4 -->
          <article class="faq-item rounded-xl">
            <button id="q4" aria-expanded="false" aria-controls="p4" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
                 hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Qué pasa si me dejan un reclamo?
              </span>
              <span class="icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p4" role="region" aria-labelledby="q4"
              class="faq-panel overflow-hidden px-5 rounded-b-2xl bg-slate-100" style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                Recibirás una notificación y podrás responder desde la plataforma. Si contratas el servicio
                gestionado, ¡nosotros respondemos por ti!
              </div>
            </div>
          </article>

          <!-- Item 5 -->
          <article class="faq-item rounded-xl">
            <button id="q5" aria-expanded="false" aria-controls="p5" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
                 hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Qué pasa después del primer <br class="lg:hidden"> año si elegí el plan anual?
              </span>
              <span class="icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p5" role="region" aria-labelledby="q5"
              class="faq-panel overflow-hidden px-5 rounded-b-2xl bg-slate-100" style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                Podrás renovarlo fácilmente por el mismo precio.
              </div>
            </div>
          </article>

          <!-- Item 6 -->
          <article class="faq-item rounded-xl">
            <button id="q6" aria-expanded="false" aria-controls="p5" class="faq-trigger w-full text-left px-5 py-4 flex items-center justify-between gap-4
                 hover:bg-slate-50 transition">
              <span class="font-medium text-slate-900">
                ¿Qué incluye el plan de por vida?
              </span>
              <span class="icon grid place-content-center w-8 h-8 rounded-full bg-slate-900 text-white">
                <i class="ri-add-line text-base leading-none"></i>
              </span>
            </button>
            <div id="p5" role="region" aria-labelledby="q6"
              class="faq-panel overflow-hidden px-5 rounded-b-2xl bg-slate-100" style="height:0">
              <div class="pb-3 pt-0 text-[15px] leading-relaxed text-slate-600">
                Acceso completo, actualizaciones permanentes y soporte preferente sin necesidad de
                renovaciones.
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <Testimonials />

    <!-- Footer -->
    <footer class="bg-[#101828] mt-[86px]">
      <div class="container mx-auto pt-9 flex flex-col lg:flex-row">
        <!-- Col 1 -->
        <div class="text-white p-8 md:p-0 lg:w-[696px]">
          <div class="text-[13px]">
            <a href="#" class="flex items-center mb-4">
              <img src="@/core/assets/images/logos/logo-zet.png" alt="Logo Zet" class="h-12 mr-2" />
              <span class="font-roboto font-bold text-2xl text-[#84509A]">ZET</span>
            </a>
        
            <p class="text-[#A7A8A9]">
              <span class="text-white font-bold">ZET</span> es la plataforma digital líder en Libro de Reclamaciones Digital online en Perú, diseñada para que negocios de todos los tamaños cumplan fácilmente con la normativa de Indecopi.
            </p>

            <p class="text-[#A7A8A9] mt-2">
             Nuestra solución permite registrar y gestionar reclamos de manera rápida, segura y desde cualquier dispositivo, garantizando transparencia y confianza en la atención al cliente.
            </p>

            <p class="text-[#A7A8A9] mt-2">
              Con <span class="text-white font-bold">ZET</span> tu empresa no solo cumple con la ley, sino que también mejora la experiencia de sus consumidores al ofrecer un canal moderno, accesible y totalmente digital. Trabajamos con tiendas, restaurantes, clínicas, colegios, agencias de viajes, salones de belleza, profesionales independientes y más.
            </p>

            <p class="text-[#A7A8A9] mt-2">
              Simplifica tu gestión de libros de reclamaciones con <span class="text-white font-bold">ZET</span> y mantén tu negocio siempre en regla
            </p>
          </div>

          <div class="mt-[18px]">
            <ul>
              <li class="flex items-center">
                <img
                  src="data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17%2020H3C1.34315%2020%200%2018.6569%200%2017V1C0%200.44772%200.44772%200%201%200H15C15.5523%200%2016%200.44772%2016%201V13H20V17C20%2018.6569%2018.6569%2020%2017%2020ZM16%2015V17C16%2017.5523%2016.4477%2018%2017%2018C17.5523%2018%2018%2017.5523%2018%2017V15H16ZM14%2018V2H2V17C2%2017.5523%202.44772%2018%203%2018H14ZM4%205H12V7H4V5ZM4%209H12V11H4V9ZM4%2013H9V15H4V13Z'%20fill='white'/%3e%3c/svg%3e"
                  alt="Términos y condiciones" class="mr-2" />
                <a href="" target="_blank" class="text-white font-semibold hover:text-[#84509A]">Términos y
                  condiciones</a>
              </li>

              <a href="" target="_blank" class="inline-block mt-4">
                <img src="@/core/assets/images/home/libro-de-reclamaciones.png" alt="Libro de reclamaciones - ZET">
              </a>
            </ul>
          </div>
        </div>

        <!-- Col 2 -->
        <div class="lg:ml-[119px] p-8 md:p-0 lg:mt-0">
          <h3 class="text-[22px] text-white font-bold mb-[18px]">
            Contáctanos
          </h3>

          <ul class="font-normal">
            <li class="flex items-center">
              <CellphoneIcon class="fill-primary mr-3" />
              <a href="tel:+51908901200" target="_blank" class="text-[21px] text-white">+51 908 901 200</a>
            </li>
            <li class="flex items-center mt-4">
              <WhatsappIcon class="fill-primary mr-3" />
              <a href="https://wa.me/51908901200?text=Hola%20quiero%20información%20sobre..." target="_blank"
                class="text-[21px] text-white">+51 908 901 200</a>
            </li>
            <!-- <li class="flex items-center mt-4">
                <img
                  src="./assets/images/layout/footer/mail.svg"
                  alt="Términos y condiciones"
                  class="mr-2"
                />
                <a
                  href="mailto:publicidad@wize.pe"
                  target="_blank"
                  class="text-wize-gray-3"
                  >publicidad@wize.pe</a
                >
              </li> -->
          </ul>

          <div class="flex mt-10 md:mt-7">
            <a href="https://web.facebook.com/wize.pe" target="_blank">
              <!-- <img
                src="data:image/svg+xml,%3csvg%20width='44'%20height='45'%20viewBox='0%200%2044%2045'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_2086_26)'%3e%3cpath%20d='M44%2022.5C44%2010.3497%2034.1503%200.5%2022%200.5C9.84973%200.5%200%2010.3497%200%2022.5C0%2033.4807%208.04504%2042.5823%2018.5625%2044.2327V28.8594H12.9766V22.5H18.5625V17.6531C18.5625%2012.1394%2021.847%209.09375%2026.8722%209.09375C29.2785%209.09375%2031.7969%209.52344%2031.7969%209.52344V14.9375H29.0228C26.29%2014.9375%2025.4375%2016.6335%2025.4375%2018.375V22.5H31.5391L30.5637%2028.8594H25.4375V44.2327C35.955%2042.5823%2044%2033.4807%2044%2022.5Z'%20fill='%2300BCD4'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_2086_26'%3e%3crect%20width='44'%20height='44'%20fill='white'%20transform='translate(0%200.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
                alt="Razzil - Facebook" /> -->

                <Facebook class="fill-primary" />
            </a>

            <a href="" class="ml-8">
              <Instagram class="fill-primary" />
            </a>

            <a href="" class="ml-8">
              <TikTok class="fill-primary" />
            </a>

            <!-- <a href="" class="ml-8">
                <img
                  src="./assets/images/layout/footer/youtube.svg"
                  alt="Razzil - Youtube"
                />
              </a> -->
          </div>

          <h3 class="text-[22px] text-white font-bold mt-16 text-center text-md-left">
            Datos de la empresa
          </h3>

          <div class="mt-[6px] text-center text-md-left">
            <div class="flex flex-col">
              <span class="text-white text-sm font-semibold">R.U.C.</span>
              <span class="text-base text-[#A7A8A9] font-semibold">20601681651</span>
            </div>

            <div class="flex flex-col mt-4">
              <span class="text-white text-sm font-semibold">Razón Social</span>
              <span class="text-base text-[#A7A8A9] font-semibold">WIZE PERU S.A.C.</span>
            </div>
          </div>
        </div>
      </div>

      <div class="container mx-auto mt-6">
        <div class="w-full h-[1px] bg-white"></div>

        <div class="flex flex-col pt-4 lg:flex-row lg:justify-between items-center">
          <a href="https://wize.pe" target="_blank" class="flex items-center gap-2">
            <img src="@/core/assets/images/logos/logo-wize.png" alt="Logo Wize" class="h-10" />
          </a>
          
          <p class="text-[10px] text-white text-center mt-6 lg:mt-0 lg:text-left lg:hidden">
            Todos los derechos reservados © 2025. Forjado por <a href="https://wize.pe/" target="_blank"
              class="text-[#14B8A6]">Wize</a>
          </p>

          <p class="hidden text-white text-center mt-6 md:flex md:items-center lg:mt-0 my-0">
            Forjado por
            <a href="https://wize.pe/" target="_blank" class="text-[#14B8A6] inline-block mx-1">Wize</a> © {{ year }}. Todos los
            derechos reservados
          </p>
        </div>
      </div>
    </footer>

    <a href="https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20Zet%20-%20Libro%20de%20Reclamaciones" target="_blank">
      <img src="@/core/assets/images/home/whatsapp.png" alt="Zet Whatsapp" class="fixed bottom-6 right-4 max-w-[193px] z-50 hover:scale-95 transition-transform duration-200" />
    </a>
  </div>
</template>

<script>
import Facebook from '@/core/components/icons/social/Facebook.vue';
import Instagram from '@/core/components/icons/social/Instagram.vue';
import TikTok from '@/core/components/icons/social/TikTok.vue';
import CellphoneIcon from '@/core/components/icons/social/CellphoneIcon.vue';
import WhatsappIcon from '@/core/components/icons/social/WhatsappIcon.vue';
import PricingPlans from '../../../core/components/landing/PricingPlans.vue';
import Testimonials from '../../../core/components/landing/Testimonials.vue';

export default {
  name: "LoginPage",
  components: {
    Facebook,
    Instagram,
    TikTok,
    CellphoneIcon,
    WhatsappIcon,
    PricingPlans,
    Testimonials
  },
  data() {
    return {
      year: new Date().getFullYear(),
      swiperOptionsMobile: {
        slidesPerView: 2,
        loop: true,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-custom-next",
          prevEl: ".swiper-custom-prev",
        }
      },
      swiperOptionsDesktop: {
        slidesPerView: 5,
        loop: true,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-custom-next",
          prevEl: ".swiper-custom-prev",
        }
      }
    };
  },
  methods: {
    setMenuAction() {
      const menuBtn = document.getElementById('menuBtn');
      const closeMenu = document.getElementById('closeMenu');
      const panel = document.getElementById('mobilePanel');
      const overlay = document.getElementById('mobileOverlay');

      function openPanel() {
        overlay.classList.remove('hidden');
        requestAnimationFrame(() => {
          overlay.classList.remove('opacity-0');
          panel.classList.remove('translate-x-full');
        });
        document.documentElement.style.overflow = 'hidden';
        menuBtn?.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        overlay.classList.add('opacity-0');
        panel.classList.add('translate-x-full');
        panel.addEventListener('transitionend', () => {
          overlay.classList.add('hidden');
        }, { once: true });
        document.documentElement.style.overflow = '';
        menuBtn?.setAttribute('aria-expanded', 'false');
      }

      menuBtn?.addEventListener('click', openPanel);
      closeMenu?.addEventListener('click', closePanel);
      overlay?.addEventListener('click', closePanel);
      window.addEventListener('keydown', (e) => e.key === 'Escape' && closePanel());

      // 🔹 Cerrar menú al hacer clic en un enlace dentro del panel
      document.querySelectorAll('#mobilePanel a').forEach(link => {
        link.addEventListener('click', () => {
          closePanel();
        });
      });
    },
    setCollapseAction() {
      document.querySelectorAll('.faq-trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';

          // Cierra todos
          document.querySelectorAll('.faq-trigger').forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('bg-slate-100');
            btn.nextElementSibling.style.height = '0';
            btn.querySelector('i').className = 'ri-add-line text-base leading-none';
          });

          // Abre el actual si estaba cerrado
          if (!expanded) {
            trigger.setAttribute('aria-expanded', 'true');
            trigger.classList.add('bg-slate-100');
            const panel = trigger.nextElementSibling;
            panel.style.height = panel.scrollHeight + 'px';
            trigger.querySelector('i').className = 'ri-subtract-line text-base leading-none';
          }
        });
      });
    }
  },
  computed: {
    adminUrl: function () {
      return process.env.VUE_APP_ADMIN_URL;
    }
  },
  mounted() {
    this.setMenuAction()
    this.setCollapseAction()
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/home-page';
</style>
